(async function () {
    async function loadingWait() {
        return await new Promise((resolve) => {
            var timerInterval = setInterval(function () {
                if (typeof app != "undefined") {
                    if (app._data.firstInstall == true) {
                        console.log("app._data.firstInstall");
                        clearInterval(timerInterval);
                        resolve();
                    }
                } else {
                    clearInterval(timerInterval);
                    resolve();
                }
                console.log("test----");
            }, 250);
        });
    }
if (window.location.pathname == "/") {
    await loadingWait();
    $(".card-sliders").slick({
        infinite: true,
        slidesToShow: 3,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    });

    $(document).on("click", ".card-slider", function (e) {
        var data = customSearch(
            $("#food-cards .card"),
            null,
            "div.datas",
            $(this).data("ids")
        );
        $(".div-for-foods").css({
            display: "none",
        });
        $(".div-for-search").css({
            display: "block",
        });

        if (typeof app == "undefined") {
            var list =
                '<div class="row" style="display: none;">' +
                '<div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3 div-for-back">' +
                '<button type="button" class="btn btn-lg btn-warning btn-block"><i class="fas fa-arrow-circle-left"></i> All Menu</button>' +
                "<br>";

            if (data.length > 0) {
                list +=
                    '<div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-3">';
                $.each(data, function (key, val) {
                    list += '<div class="col">' + val[0].outerHTML + "</div>";
                });
                list += "</div>";
            } else {
                list +=
                    '<div class="col" style="font-size: 1.50rem; ">No results were found.</div>';
            }
            list += "</div></div>";

            $(".div-for-search").html(list);

            $("div.div-for-back").closest(".row").css({
                display: "block",
            });
        }

        $("html, body").animate(
            {
                scrollTop: $("#focus-search").position().top,
            },
            500
        );
    });

    $(document).on("click", "div.div-for-back button", function () {
        if (typeof app != "undefined") {
            $(".div-for-foods").css({
                display: "block",
            });
            $(".div-for-search").css({
                display: "none",
            });
        }else{
            $("div.div-for-back").closest(".row").css({
                display: "none",
            });
            resetMenu();
        }
    });

    $(document).ready(function () {
        if ($("#foods-search").length) {
            document
                .getElementById("foods-search")
                .addEventListener("search", function () {
                    if (this.value.length == 0 || this.value == "") {
                        $(".div-for-foods").css({
                            display: "block",
                        });
                        $(".div-for-search").css({
                            display: "none",
                        });
                        $(".main-tab .tab-pane.fade")
                            .removeClass("active")
                            .first()
                            .addClass("show active");
                        $("#v-pills-tab .list-group .list-group-item")
                            .removeClass("active")
                            .first()
                            .addClass("active");
                    }
                });
        }
    });

    $(document).on("keyup", "#foods-search", function (e) {
        var data = customSearch(
            $("#food-cards .card"),
            $("#foods-search"),
            ".card-text, h6"
        );
        if (
            $("#foods-search").val().trim().length != 0 ||
            $("#foods-search").val() != ""
        ) {
            $(".div-for-foods").css({
                display: "none",
            });
            $(".div-for-search").css({
                display: "block",
            });
            if (data.length > 0) {
                var list =
                    '<div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-3">';
                $.each(data, function (key, val) {
                    list += '<div class="col">' + val[0].outerHTML + "</div>";
                });
                list += "</div>";
                $(".div-for-search").html(list);
            } else {
                $(".div-for-search").html(
                    '<div class="row">' +
                        '<div class="col" style="font-size: 1.50rem; ">No results were found.</div>' +
                        "</div>"
                );
            }
        } else {
            $("div.div-for-back").closest(".row").css({
                display: "none",
            });
            resetMenu();
        }
    });

    window.customSearch = function (
        element = null,
        input = null,
        act = null,
        ids = null
    ) {
        var arr = [];
        element.filter(function () {
            if (ids == null) {
                if (
                    input.val().length > 0 &&
                    $(this)
                        .find(act)
                        .text()
                        .toLowerCase()
                        .search(input.val().toLowerCase()) > -1
                ) {
                    arr.push($(this));
                }
            } else {
                var idss = typeof ids == "string" ? JSON.parse(ids) : ids;
                if (idss.includes(parseInt($(this)[0].dataset.id)) == true) {
                    arr.push($(this));
                }
            }
        });
        return arr;
    };

    window.resetMenu = function () {
        $(".div-for-foods").css({
            display: "block",
        });
        $(".div-for-search").css({
            display: "none",
        });
        $(".main-tab .tab-pane.fade")
            .removeClass("active")
            .first()
            .addClass("show active");
        $("#v-pills-tab .list-group .list-group-item")
            .removeClass("active")
            .first()
            .addClass("active");
    };

    $(document).ready(function () {
        //window.location.hash = $('#pills-tab2 .nav-item .nav-link.active').data('url-hash');

        $("#pills-tabContent2 .pane-off").css({
            display: "none",
        });

        $(document).on(
            "click",
            "#pills-tab2 .nav-item .nav-link",
            function (event) {
                event.preventDefault();
                var parentd = $(this).data("dg-nav");
                $("#pills-tabContent2 div[data-dg-nav=tabpanel2]").css({
                    display: "none",
                });
                $("#pills-tabContent2 #" + parentd + "").css({
                    display: "block",
                });

                $("#pills-tab2 .nav-item .nav-link").removeClass("active");
                $(this).addClass("active");

                if (window.location.hash == "#booking-tab") {
                    bookingSetup();
                }
            }
        );

        var hash = window.location.hash;
        hash && $('ul.nav.nav-pills a[href="' + hash + '"]').tab("show");
        if (hash == "#booking-tab") {
            bookingSetup();
        }

        $("ul.nav.nav-pills a").click(function (e) {
            $(this).tab("show");
            window.location.hash = this.hash;
        });
    });

    $(document).on("click", ".nav-pills .col", function (event) {
        event.preventDefault();
        $("html, body").animate(
            {
                scrollTop: $("#focus-menu").position().top,
            },
            500
        );
    });

    $(document).on("click", ".footer-float-basket", function (event) {
        event.preventDefault();
        $("html, body").animate(
            {
                scrollTop: $("#focus-basket").position().top,
            },
            500
        );
    });

    $(document).ready(function () {
        $(document).on("click", ".footer-float", function () {
            $("html, body").animate(
                {
                    scrollTop: $("#focus-category").position().top,
                },
                500
            );
        });

        window.addEventListener("scroll", function (e) {
            //console.log(window.scrollY);
            if (window.scrollY >= 550) {
                $(".footer-float").css({
                    display: "block",
                });
            } else {
                $(".footer-float").css({
                    display: "none",
                });
            }

            if ($(".footer-float").is(":visible")) {
                $(".footer-float-basket").css({
                    bottom: "90px",
                });
            } else {
                $(".footer-float-basket").css({
                    bottom: "30px",
                });
            }
        });

        if (window.scrollY >= 550) {
            $(".footer-float").css({
                display: "block",
            });
        } else {
            $(".footer-float").css({
                display: "none",
            });
        }

        if ($(".footer-float").is(":visible")) {
            $(".footer-float-basket").css({
                bottom: "90px",
            });
        } else {
            $(".footer-float-basket").css({
                bottom: "30px",
            });
        }
    });
}
})();
